export default __webpack_public_path__ + "static/media/layerLeft2.9781f8e9.webp";